/**
 * Hub header height comes from its label plus the Figma vertical padding.
 * Longer labels grow the shared header row naturally instead of forcing every
 * table to the 64px height shown by the two-line Figma example.
 */
export const hubGridIntrinsicHeaderSx = {
    "& thead > tr": {
        height: "auto !important",
        maxHeight: "none !important",
        minHeight: "unset !important",
    },
    "& thead > tr > th": {
        height: "auto !important",
        maxHeight: "none !important",
        minHeight: "unset !important",
    },
} as const;
